const API = {
  getListByPage:"/product/market_actitity/getListByPage",
  getTreeSelectData:"/product/category/getTreeSelectData",//商品目录
  getByOfferingId:"/product/product-offer/getByOfferingId",//根据商品id获取商品信息详情
  getByOfferingId:"/product/product-offer/getByOfferingId",//根据商品id获取商品信息详情
  getPosterList:"/v1/qr/poster/getPosterList",//获取海报列表
}
export default API